import { useParams } from 'react-router';
import { Params, useLocation } from 'react-router-dom';

export const useCheckPath = (path: string): [boolean, Readonly<Params>] => {
  const location = useLocation();
  const isOnPage = location.pathname.startsWith(path);
  const urlParams = useParams();
  return [isOnPage, urlParams];
};
